import React, { Component } from 'react'
import { connect } from 'react-redux'

import InstrumentMobile from '../../Instrument/Instrument.mobile'

class QuoteMobile extends Component {
  constructor(props){
    super(props)
    this.state={
      pieChart:true,
      placeOrder:false
    }
  }
  render() {
    const {pieChart,placeOrder} = this.state
    return (
      <div className='qoute-moblie' style={{height:'100%'}}>
        <InstrumentMobile 
        index 
        bidask 
        pieChart={pieChart} 
        placeOrder={placeOrder} 
        TrendChartFlag 
        showStockInfo={false} 
        showInput={false} 
        isDetailCenter
        handleSwitchToPlaceOrder={() => this.handleSwitchToPlaceOrder()}
        handleSwitchToCharts = {() => this.handleSwitchToCharts()}
        ></InstrumentMobile>
      </div>
    )
  }

  handleSwitchToPlaceOrder = () =>{
    if((this.state.pieChart == false) && (this.state.placeOrder == true)) return
    this.setState({pieChart:false,placeOrder:true})
  }
  handleSwitchToCharts = () =>{
    this.setState({pieChart:true,placeOrder:false})
  }
}


export default connect(state =>({
  language: state.app.language,
}),
diaptch =>({

}))(QuoteMobile)